"use strict";

import angular from "angular";

import template from "./nanda-chat-message-assistant.component.html";
import "./nanda-chat-message-assistant.component.scss";

class NandaChatMessageAssistantComponent {
    isPlayingAudio = false;
    constructor() {}

    $onInit() {}

    onSelectOption(option) {
        this.handleSelectOption({ option });
    }

    onSelectAction(action, content) {
        if (this.thinking) return;
        if (action.value === "copy") {
            this.copyContent(content);
        }
        if (action.value === "audio") {
            if (this.isPlayingAudio) {
                action.icon = "fas fa-volume-up";
                this.cancelAudio();
                return;
            }
            action.icon = "fas fa-volume-mute";
            this.playAudio(content);
        }
    }

    copyContent(content) {
        const plainText = this.getPlainText(content?.text);
        navigator.clipboard.writeText(plainText);
    }

    playAudio(content) {
        this.isPlayingAudio = true;
        const text = this.getPlainText(content?.text);
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.onstart = () => {
            console.log("onstart");
            this.isPlayingAudio = true;
        };
        utterance.onend = () => {
            console.log("onend");
            this.isPlayingAudio = false;
        };
        utterance.lang = "pt-BR";
        speechSynthesis.speak(utterance);
    }

    cancelAudio() {
        speechSynthesis.cancel();
        this.isPlayingAudio = false;
    }

    getPlainText(text) {
        if (!text) return "";
        return text?.replace(/<[^>]*>/g, "") || "";
    }
}

NandaChatMessageAssistantComponent.$inject = [];

const name = "nandaChatMessageAssistantComponent";
const def = {
    bindings: {
        message: "<",
        handleSelectOption: "&"
    },
    controller: NandaChatMessageAssistantComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
